import styled from 'styled-components';

interface IContainerProps {
    shown?: boolean;
}

export const Container = styled.div<IContainerProps>`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    cursor: ${({ shown }) => (shown ? 'loading' : 'default')};
    pointer-events: ${({ shown }) => (shown ? 'all' : 'none')};
    opacity: ${({ shown }) => (shown ? 1 : 0)};
    transition: opacity ${({ theme }) => theme.transitions.hover};
`;
